import { render, staticRenderFns } from "./ProvideBattleResults.vue?vue&type=template&id=5fff6f54&"
import script from "./ProvideBattleResults.vue?vue&type=script&lang=js&"
export * from "./ProvideBattleResults.vue?vue&type=script&lang=js&"
import style0 from "./ProvideBattleResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports